export const GET_TRANSACTION = 'CASH_IN/get_transaction';
export const SHOW_TRANSACTION = 'CASH_IN/show_transaction';

export const FORM_DATA = {
  status: 'REJECT',
  remarks: '',
};
